import React from 'react';

import Button from 'components/Button';
import { ICONS_MAP } from 'constants/icons';
import { appReactMemo } from 'hocs';

import { StyledTooltip } from './styled';

export interface IWarningButton {
  children: string;
  maxWarningWidth?: number;
}

const WarningButton = ({ children, maxWarningWidth = 300 }: IWarningButton) => {
  return (
    <StyledTooltip $maxWarningWidth={maxWarningWidth} component={children} showOnClick>
      <Button
        enableShowFocus
        iconSize={16}
        size='xxs'
        startIcon={<ICONS_MAP.DangerExclamation />}
        variant='transparentWarning'
      />
    </StyledTooltip>
  );
};

export default appReactMemo(WarningButton);
